enum ProjectType {
  none,
  project,
  concept,
  scenario,
}

export default ProjectType;
